// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2076":"common","2928":"toolingLoaderWorker","4412":"customerToolingLoaderWorker"}[chunkId] || chunkId) + ".js";
};